import { appActions } from "../../action";
export const handlePopupModalAction = payload => ({
  type: appActions.HANDLE_MODAL,
  payload
});